import { Tournament } from '../models';

/**
 * Resolve the LPGA identifier associated with a tournament.
 * Prefers the explicit importSourceId and falls back to the LPGA external ID value.
 */
export function resolveTournamentLpgaId(tournament: Tournament | null | undefined): number | undefined {
  if (!tournament) {
    return undefined;
  }

  if (typeof tournament.importSourceId === 'number' && tournament.importSourceId > 0) {
    return tournament.importSourceId;
  }

  const lpgaExternalId = tournament.externalIds?.find(
    (extId) => extId.organization?.toUpperCase() === 'LPGA'
  )?.externalId;

  if (!lpgaExternalId) {
    return undefined;
  }

  const parsed = Number.parseInt(lpgaExternalId, 10);
  return Number.isFinite(parsed) ? parsed : undefined;
}
